module.exports = __webpack_public_path__ + "static/media/back.044d88a9.svg";